export default __webpack_public_path__ + "static/media/self.f6b36ef2.jpeg";